/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import PaymentProcessorsList from "../booking/PaymentProcessorsList";
import PaymentProcessorItem from "../booking/PaymentProcessorItem";

const SavedPaymentMethodsList = ({ methods, selectedId, onSelect, ...props }) => (
  <PaymentProcessorsList
    title="Stored payment method"
    subtitle="Please select a payment method you saved earlier"
    {...props}
  >
    {methods.map((method) => (
      <PaymentProcessorItem
        key={method.id}
        processor={{ id: method.id, name: method.payment_system }}
        label={method.name}
        selected={selectedId === method.id}
        onClick={() => onSelect(method.id)}
      />
    ))}
  </PaymentProcessorsList>
);

export default SavedPaymentMethodsList;
